export default __webpack_public_path__ + "static/media/Group 5796.3f49171e.svg";